import { Injectable } from '@angular/core';
import { SchoolSystem, State } from '../models/state.model';
import { Representative } from '../models/representative.model';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  state: State = {
    consent: {
      student: {
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: null,
        gender: '',
        phoneNumber: '',
        email: '',
        schoolId: '',
        primaryLanguage: '',
        tobacco: null,
        alcohol: null,
        address: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          zip: ''
        }
      },
      guardians: [
      ],
      emergencyContact: {
        firstName: '',
        middleName: '',
        lastName: '',
        relationship: '',
        phoneNumber: '',
        email: ''
      },
      primaryCareProvider: {
        name: '',
        phoneNumber: ''
      },
      preferredPharmacy: {
        name: '',
        phoneNumber: ''
      },
      hipaa: {
        acknowledgement: false,
        representatives: []
      },
      myNortonChart: false,
      medicalHistory: {
        allergies: false,
        asthma: false,
        bone: false,
        hearingVision: false,
        seizure: false,
        stomach: false,
        anxiety: false,
        bleeding: false,
        cancer: false,
        diabetes: 'None',
        other: '',
        explanation: '',
      },
      surgicalHistory: {
        appendix: false,
        heart: false,
        gallbladder: false,
        tonsils: false,
        other: '',
        explanation: ''
      },
      medications: [],
      permissionToExamine: false,
      authorize: {
        release: false,
        read: false // field removed from UI
      },
      signature: {
        termId: '',
        fullName: '',
        image: ''
      },
      insurances: []
    },
    relationships: ['Family Friend', 'Family Relation (other)', 'Father', 'Grandparent', 'Guardian', 'Mother', 'Sibling'],
    guardianRelationships: ['Father', 'Mother', 'Guardian'],
    insurances:[
      'NO INSURANCE',
      'TRICARE/HEALTHNET',
      'AETNA',
      'ANTHEM',
      'CIGNA',
      'KHCP',
      'HUMANA',
      'MEDICAID KENTUCKY',
      'ADVANTRA FREEDOM',
      'PASSPORT ADVANTAGE',
      'ACTIVE DUTY MILITARY',
      'PASSPORT HEALTH PLAN',
      'CCHA',
      'UNITED HEALTHCARE',
      'BEECH STREET',
      'BAPTIST HEALTH PLAN',
      'BLUEGRASS FAMILY HLTH SINGLE S',
      'CHA HEALTH',
      'COVENTRY HEALTH CARE',
      'KY RACING HEALTH & WELFARE',
      'KY COMMISSION FOR CHILDREN',
      'WELLCARE OF KENTUCKY',
      'KENTUCKY SPIRIT',
      'HUMANA CARESOURCE',
      'KENTUCKY HEALTH CO - OPERTIVE',
      'ANTHEM PATHWAY KENTUCKY',
      'TEAMCARE(UPS)',
      'CARESOURCE EXCHANGE',
      'WELLCARE KY EXCHANGE',
      'Anthem Indiana Medicaid',
      'CareSource Indiana',
      'MD - Wise',
      'Managed Health Services(MHS)',
      'UnitedHealthCare Community Plan MCO',
      'Anthem Pathway Indiana',
      'Aetna Assurant Exchange with Reciprocity',
      'CareSource IN Marketplace',
      'MHS A  mbetter Indiana',
      'OTHER'
    ],
    potentialRepresentatives: [],
    schoolName: '',
    isStaff: false,
    schoolSystem: SchoolSystem.None
  };
 
  constructor() { }

  // Function to add potential phis (guardians or emergency contact) to state.potentialPhis
  // to show list on hipaa view and user might add any of them as phi contact
  addPotentialRepresentative(rep: any) {
    const representative: Representative = {
      firstName: rep.firstName,
      middleName: rep.middleName,
      lastName: rep.lastName,
      relationship: rep.relationship,
      phoneNumber: rep.phoneNumber,
      checked: false
    };

    this.state.potentialRepresentatives.push(representative);
  }

  clearConsent() {
    //this.state.consent.
  }

}
